import axios from "axios"; // 引入axios
import qs from "qs"; // 序列化字符串


// 请求超时时间
axios.defaults.timeout = 50000;

//let Base = "http://117.78.7.31:7001";
let Base = "https://smartcity.honghengxinxi.com";
// let Base = "http://192.168.1.105:8000";
// let Base = "http://192.168.1.111:3303";


//文件上传地址
// export let fileUploadUrl = 'http://117.78.7.31:7001/image/community/add'

// 环境切换
if (process.env.NODE_ENV == 'development') { //生产环境走的地址
  Base = "https://smartcity.honghengxinxi.com"; //线上

  // Base = "http://192.168.1.111:8000";   //h
  //   Base = "http://192.168.1.102:3303";
  //  Base = "http://192.168.1.105:3303";
} else if (process.env.NODE_ENV == 'production') { //测试环境地址
  Base = "https://smartcity.honghengxinxi.com"; //线上
  //Base = "http://117.78.7.31:7001"; //测试地址
} else if (process.env.NODE_ENV == 'testing') { //测试环境地址
  Base = "https://smartcity.honghengxinxi.com"; //线上
  //  Base = "http://117.78.7.31:7001"; //测试地址
}

// fileUploadUrl=Base+'image/community/add'
function headerUrl(url) {
  // if (url.substring(0, 4) == 'http') {
  //     url = url
  // } else {
  //     url = Base + url;
  // }
  return url;
}
// post请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
export default {
  /**
   * get方法对应get请求
   * @param {String}url 请求地址
   * @param {Object}params携带参数
   * @returns {Promise}
   */
  // fileUploadUrl,
  get(url, params,timeout) {
    return new Promise((resolve, reject) => {
      axios
        .get(headerUrl(url), {
          params: params
        },{timeout: timeout||10000})
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },
  /**
   * post方法对应post请求
   * @param {String} url 请求地址
   * @param {Object} params 携带参数
   * @returns {Promise}
   */
  post(url, params) {
    return new Promise((resolve, reject) => {
      axios
          // .post(headerUrl(url), qs.stringify(params), {
        .post(headerUrl(url), params, {
          // "headers": {
          //   "token": headers
          // }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/http.js